import { motion } from "framer-motion";
import { Phone, CheckCircle } from "@phosphor-icons/react";
import { PHONE, PHONE_HREF, IMAGES, TRUST_ITEMS } from "@/data/content";

const scrollTo = (id) =>
  document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });

export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center" data-testid="hero-section">
      <div className="absolute inset-0">
        <img src={IMAGES.hero} alt="Professional house cleaning by Explus Cleaning LLC in a bright, spotless Everett, WA living room" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-primary/90 via-primary/70 to-primary/30" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-10 pt-28 pb-20 w-full">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl pb-24 md:pb-0"
        >
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-emerald-200 mb-5">
            Reliable • Detailed • Professional
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light tracking-tighter text-white leading-[1.05] sm:leading-[1.02]">
            A cleaner space starts with Explus Cleaning
          </h1>
          <p className="mt-6 text-lg text-white/85 max-w-xl leading-relaxed">
            Professional house, deep, office and commercial cleaning for homes,
            apartments, rentals and move-in / move-out needs — serving Lynnwood,
            Everett, Edmonds and nearby Washington communities.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => scrollTo("#quote")}
              className="rounded-full bg-white text-primary font-semibold px-8 py-4 hover:-translate-y-0.5 hover:shadow-xl transition-all"
              data-testid="hero-quote-btn"
            >
              Request a Free Quote
            </button>
            <a
              href={PHONE_HREF}
              className="rounded-full border border-white/70 text-white font-semibold px-8 py-4 flex items-center justify-center gap-2 hover:bg-white/10 transition-colors"
              data-testid="hero-call-btn"
            >
              <span className="call-ring"><Phone className="call-shake" size={20} weight="fill" /></span> Call {PHONE}
            </a>
          </div>

          <div className="mt-10 flex flex-wrap gap-x-6 gap-y-3">
            {TRUST_ITEMS.map((t) => (
              <span key={t} className="flex items-center gap-2 text-white/90 text-sm font-medium" data-testid="trust-item">
                <CheckCircle size={20} weight="fill" className="text-emerald-300 shrink-0" /> {t}
              </span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
